import AvailableProfileModel from 'modules/App/models/AvailableProfile';
import ContactModel from 'modules/App/models/Contact';
import SearchedProfileModel from 'modules/App/models/SearchedProfile';
import HomePage from 'modules/Marketing/pages/HomeV2';
import UserModel from 'modules/User/models/User';
import { getServerSession } from 'modules/auth/server';
import type { GetServerSideProps } from 'next';
import dbConnect from 'utils/db';

export const getServerSideProps: GetServerSideProps = async (context) => {
  await dbConnect();
  const session = await getServerSession(context);

  if (context.locale === 'en') {
    return {
      redirect: {
        destination: '/fr',
        permanent: false,
      },
    };
  }

  const nbMembers = await UserModel.countDocuments({ roles: 'member' });
  const nbContacts = await ContactModel.countDocuments({ candidate: { $exists: true } });
  const nbSearchedProfiles = await SearchedProfileModel.countDocuments({
    publishedAt: { $exists: true, $ne: null },
    expiresAt: { $gte: new Date() },
  });
  const nbAvailableProfiles = await AvailableProfileModel.countDocuments({
    publishedAt: { $exists: true, $ne: null },
    expiresAt: { $gte: new Date() },
  });
  const bountyAmount =
    (
      await SearchedProfileModel.aggregate([
        { $match: { publishedAt: { $exists: true, $ne: null }, expiresAt: { $gte: new Date() } } },
        {
          $group: {
            _id: null, // Grouping all documents together. Change this to group by a specific field.
            totalBountyStart: { $sum: '$bountyStart' },
            totalBountyConfirm: { $sum: '$bountyConfirm' },
          },
        },
        {
          $project: {
            bounty: { $add: ['$totalBountyStart', '$totalBountyConfirm'] },
          },
        },
      ])
    )[0]?.bounty || 0;

  const avatars = await UserModel.find({ roles: 'topmember' }).limit(20).select('image').lean();

  // if (session) {
  //   return {
  //     redirect: {
  //       destination: '/fr/my-missions',
  //       permanent: false,
  //     },
  //   };
  // }

  return {
    props: {
      session: JSON.parse(JSON.stringify(session)),
      avatars: JSON.parse(JSON.stringify(avatars)),
      stats: { nbMembers, nbContacts, nbSearchedProfiles, nbAvailableProfiles, bountyAmount },
    },
  };
};

export default HomePage;
